import pathToRegexp from 'path-to-regexp';
import URI from 'urijs';

/**
 * @example
 * const { query, params } = urlParser('/material/:type?', 'producs/2');
 * // query = null, params = { type: 2 }
 *
 * @description This function provides custom url parsing with given pattern and path.
 * @param {Regex} pattern Regular expression @see https://github.com/pillarjs/path-to-regexp
 * @param {String} path It can be a part of the url like /foo/baz, http is not necessary
 * @returns {Boolean|Object} If returned value is Boolean path was not resolved
 */
const parser = (pattern, path) => {
  const query = new URI(path).query(true);

  const keys = [];
  // ? symbol for exact matching
  const pathRegexp = pathToRegexp(pattern, keys, { strict: false, endsWith: '?' });

  const result = pathRegexp.exec(path);

  // Result can be not resolved
  if (result) {
    const [, ...params] = result;

    const parsedParams = keys.reduce((acc, n, i) => {
      acc[n.name] = params[i];

      return acc;
    }, {});

    return {
      params: parsedParams,
      query,
    };
  }

  return false;
};

export default parser;
